import React from 'react';

const MobileIcon = ({color = 'White'}) => {
  return (
    <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.4375 1.3125C2.19141 1.3125 2 1.53125 2 1.75V12.25C2 12.4961 2.19141 12.6875 2.4375 12.6875H8.5625C8.78125 12.6875 9 12.4961 9 12.25V1.75C9 1.53125 8.78125 1.3125 8.5625 1.3125H2.4375ZM0.6875 1.75C0.6875 0.792969 1.45312 0 2.4375 0H8.5625C9.51953 0 10.3125 0.792969 10.3125 1.75V12.25C10.3125 13.2344 9.51953 14 8.5625 14H2.4375C1.45312 14 0.6875 13.2344 0.6875 12.25V1.75ZM4.625 10.9375H6.375C6.59375 10.9375 6.8125 11.1562 6.8125 11.375C6.8125 11.6211 6.59375 11.8125 6.375 11.8125H4.625C4.37891 11.8125 4.1875 11.6211 4.1875 11.375C4.1875 11.1562 4.37891 10.9375 4.625 10.9375Z"
        fill={color}
      />
    </svg>
  );
};

export default MobileIcon;
